type NavvisLink = {
  title?: string
  link?: string
}

function formatLink(link: string): string {
  const trimmed = link.trim()
  if (trimmed.length === 0) return ''
  if (!trimmed.endsWith('/')) return `${trimmed}/`
  return trimmed
}

function formatNavvisLinks(item: NavvisLink): NavvisLink {
  const formattedLink = item.link ? formatLink(item.link) : ''
  return { ...item, link: formattedLink }
}

export type { NavvisLink }
export default formatNavvisLinks
